import { Button, Grid } from '@mui/material';
import React from 'react';
import {
  Create,
  CreateProps,
  email,
  FormDataConsumer,
  NumberInput,
  SimpleForm,
  TextInput,
} from 'react-admin';
import { useHistory, useRouteMatch } from 'react-router';
import { ORDER_ITEM, SUPPLIER } from './Order.string';
import { Supplier } from './Order.type';
import SupplierAutoCompleteInput from './SupplierAutoCompleteInput';

export default function OrderItemCreate(props: CreateProps) {
  const { params } = useRouteMatch<{ orderId: string }>();
  const history = useHistory();

  return (
    <Create
      {...props}
      record={{ ...props.record, order: { id: params.orderId } }}
      resource='order-items'
      basePath='order-items'
      title={`주문관리 ${params.orderId}`}
      onSuccess={(_res) => {
        history.replace(`/order/${params.orderId}`);
      }}
    >
      <SimpleForm variant='outlined'>
        <FormDataConsumer>
          {({ formData }) => {
            const onSelect = (splr: Supplier) => {
              formData['supplierName'] = splr.name;
              formData['supplierCeoName'] = splr.ceoName;
              formData['supplierCeoEmail'] = splr.ceoEmail;
              formData['supplierCeoTelNo'] = splr.ceoTelNo;
              formData['supplierAddress'] = splr.address;
            };
            return (
              <>
                <Grid columnGap={5}>
                  <TextInput
                    label={ORDER_ITEM.NAME}
                    variant='outlined'
                    source='name'
                  />
                </Grid>
                <Grid container columnGap={5}>
                  <NumberInput
                    label={ORDER_ITEM.QUANTITY}
                    variant='outlined'
                    source='quantity'
                  />
                  <NumberInput
                    label={ORDER_ITEM.UNIT_PRICE}
                    variant='outlined'
                    size='medium'
                    source='unitPrice'
                  />
                </Grid>
                <Button
                  sx={{ height: 30 }}
                  variant='outlined'
                  size='small'
                  onClick={() => history.push('/suppliers/create')}
                >
                  공급사 생성
                </Button>
                <SupplierAutoCompleteInput onSelect={onSelect} />
                <Grid container columnGap={5}>
                  <TextInput
                    label={SUPPLIER.SUPPLIER_CEO_NAME}
                    variant='outlined'
                    source='supplierCeoName'
                  />
                  <TextInput
                    label={SUPPLIER.SUPPLIER_EMAIL}
                    variant='outlined'
                    source='supplierCeoEmail'
                    validate={email()}
                  />
                  <TextInput
                    label={SUPPLIER.SUPPLIER_CEO_TELNO}
                    variant='outlined'
                    source='supplierCeoTelNo'
                  />
                  <TextInput
                    label={SUPPLIER.SUPPLIER_ADDRESS}
                    variant='outlined'
                    source='supplierAddress'
                    fullWidth
                  />
                </Grid>
                <TextInput
                  variant='outlined'
                  source='memo'
                  multiline
                  size='medium'
                  fullWidth
                />
              </>
            );
          }}
        </FormDataConsumer>
      </SimpleForm>
    </Create>
  );
}
